import React, { useEffect, useRef } from 'react';
import { useModalManager } from '@/components/common/Modal';
import useProfessionalDevelopmentResults
  from '@/components/common/ProfessionalDevelopment/useProfessionalDevelopmentResults';
import useSlideShowContext from '@/components/admin/SlideShow/stores/useSlideShowContext';
import useFlags from '@/hooks/useFlags';
import cn from '@/utils/cn';
import { UnstyledButton } from '@/components/ui/Buttons';
import restartIcon from '../../../../../../../../../images/icons/restart-icon-purple.svg';
import styles from '../../../Navigator.module.scss';
import ConfirmResetModal from './ConfirmResetModal';

const ResetSlideShowButton = () => {
  const appendEl = useRef();
  const activityType = useSlideShowContext(state => state.activityType);
  const slideShowId = useSlideShowContext(state => state.slideShowId);
  const programId = useSlideShowContext(state => state.programId);
  const modalManager = useModalManager();
  // When flag is removed, get rid of 'legacy' styling in Navigator.module.scss
  // and merge teacherPacedUpdates into regular styles
  const { teacherPacedMode } = useFlags();

  const { data, refetch, isFetching, isRefetching } = useProfessionalDevelopmentResults({
    isEnabled: activityType === 'professional_development',
    programId,
    slideShowId,
  });

  useEffect(() => {
    if (activityType !== 'professional_development') return undefined;

    const interval = setInterval(() => refetch(), 5000);

    return () => clearInterval(interval);
  }, []);

  const isHidden = activityType === 'professional_development' && data?.slideShow?.pdStatus === 'not_started';

  if (isFetching && !isRefetching) return null;
  if (isHidden) return null;

  return (
    <>
      <UnstyledButton
        ref={appendEl}
        aria-label="Restart slideshow"
        className={cn(styles.settingsMenuRow, teacherPacedMode ? styles.teacherPacedUpdates : styles.legacy)}
        onClick={modalManager.open}
      >
        <div
          className={cn(styles.menuIconButton, teacherPacedMode ? styles.teacherPacedUpdates : styles.legacy)}
        >
          <img
            alt="restart icon"
            height={22}
            src={restartIcon}
            width={22}
          />
        </div>
        <div>Restart Slideshow</div>
      </UnstyledButton>

      {modalManager.isOpen && (
        <ConfirmResetModal
          activityType={activityType}
          data={data}
          loading={isFetching}
          modalManager={modalManager}
          slideShowId={slideShowId}
        />
      )}
    </>
  );
};

export default ResetSlideShowButton;
